import request from '@/utils/request'
import host from '@/api/base/host'

// 暴虐新概念
const bnxgn = host.path('dev', { dev: '/v1/bnxgn' })

export default {
  // 用户是否有新概念课程权益
  checkUserCoursePrivilege(data) {
    // data: { code }
    return request({ url: bnxgn('checkUserCoursePrivilege'), method: 'post', data })
  },
  // 新概念是否有匹配的友邻少年ID
  isMatchYlyk(data) {
    // data: { code }
    return request({ url: bnxgn('isMatchYlyk'), method: 'post', data })
  },
  // 对应友邻少年ID是否有相应权益
  ylykIsHavePirvilege(data) {
    // data: { code }
    return request({ url: bnxgn('ylykIsHavePirvilege'), method: 'post', data })
  },
  // 添加新概念权益
  addPrivilege(data) {
    // data: { code }
    return request({ url: bnxgn('addPrivilege'), method: 'post', data })
  },
  // 绑定手机号后添加新概念权益
  bindAndAddPrivilege(data) {
    // data: { code }
    return request({ url: bnxgn('bindAndAddPrivilege'), method: 'post', data })
  }
}
